import {
  SET_CURRENT_USER,
  UPDATE_CURRENT_USER,
  LOGOUT_USER,
  SET_LOGGED_IN,
  RESET_STORE,
  NEW_USER_RESET,
  LOGOUT_USER_LAST_USER,
  LOAD_DEBUG_STATE,
} from "../actionTypes";
const defaultState = {
  userDetails: {},
  loggedIn: false,
  lastUser: null,
  updateTime: null,
};

const user = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        userDetails: payload,
        loggedIn: true,
        updateTime: new Date().getTime(),
      };
    case UPDATE_CURRENT_USER:
      return {
        ...state,
        userDetails: payload,
        loggedIn: true,
        updateTime: new Date().getTime(),
      };
    case LOGOUT_USER:
      return {
        ...defaultState,
        lastUser: state.userDetails.customerId,
        loggedIn: false,
      };
    case LOGOUT_USER_LAST_USER:
      return {
        ...defaultState,
        lastUser: state.lastUser,
        loggedIn: false,
      };
    case SET_LOGGED_IN:
      return {
        ...state,
        loggedIn: payload,
      };
    case RESET_STORE:
      return { ...defaultState };
    case NEW_USER_RESET:
      return { ...state, lastUser: state.userDetails.customerId };
    case LOAD_DEBUG_STATE:
      console.log(payload);
      let debugState = payload.user;
      return { ...state, ...debugState };
    default:
      return state;
  }
};

export default user;
